import { render, staticRenderFns } from "./detail-appointment.vue?vue&type=template&id=6d206949"
import script from "./detail-appointment.vue?vue&type=script&lang=js"
export * from "./detail-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports